import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  createGroup(payload: { groupName: string; isCommon: boolean; isActive?: boolean; customerId?: number | string }): Observable<any> {
    const url = `${this.apiUrl}/ota/v1/group`;
    return this.http.post(url, payload);
  }

  updateGroup(groupId: number | string, payload: { groupName: string; isCommon: boolean; isActive?: boolean; customerId?: number | string }): Observable<any> {
    const url = `${this.apiUrl}/ota/v1/group/${groupId}`;
    return this.http.put(url, payload);
  }

  searchGroups(payload: any): Observable<any> {
    const url = `${this.apiUrl}/ota/v1/group/search`;
    return this.http.post(url, payload);
  }

  getGroupById(groupId: number | string): Observable<any> {
    const url = `${this.apiUrl}/ota/v1/group/${groupId}`;
    return this.http.get(url);
  }

  deleteGroup(groupId: number | string): Observable<any> {
    const url = `${this.apiUrl}/ota/v1/group/${groupId}`;
    return this.http.delete(url);
  }

  /** Fetch all groups already assigned to a customer */
  getGroupsByCustomer(customerId: number | string): Observable<any> {
    const url = `${this.apiUrl}/ota/v1/group/customer/${customerId}`;
    return this.http.get(url);
  }

  /**
   * GET /customers/v1/customer/{customerId}/groups/assignment
   * Returns all active groups with assigned=true/false flag for this customer.
   */
  getGroupsForAssignment(customerId: number | string): Observable<any> {
    const url = `${this.apiUrl}/customers/v1/customer/${customerId}/groups/assignment`;
    return this.http.get(url);
  }

  /** Assign (replace) the full list of groups for a customer.
   *  PUT /customers/v1/customer/{customerId}/groups/assignment
   */
  assignGroupsToCustomer(
    customerId: number | string,
    assignments: { groupId: number | string; wiliotGatewayFormatEnabled: boolean }[]
  ): Observable<any> {
    const url = `${this.apiUrl}/customers/v1/customer/${customerId}/groups/assignment`;
    return this.http.put(url, { customerId, assignments });
  }
}
